import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=de4a2d46&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=de4a2d46&prod&scoped=true&lang=css"
import style1 from "./Changelog.vue?vue&type=style&index=1&id=de4a2d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4a2d46",
  null
  
)

export default component.exports